import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsApiService } from '@recruitee/integrations/http';

import { Source } from '../../../types';
import { sourceCompoundId } from '../../../utils';

@Injectable({ providedIn: 'root' })
export class SourceHttpClient {
  constructor(private httpApi: IntegrationsApiService) {}

  public fetch(): Observable<Source[]> {
    return this.httpApi
      .get('field-mapping/sources')
      .pipe(map(({ sources }: { sources: Source[] }) => sources.map(this.extendSource)));
  }

  private extendSource(source: Source) {
    return { ...source, compoundId: sourceCompoundId(source) };
  }
}
